import React, { useContext } from 'react'
import useNetworkState from '../../../../hooks/useNetworkState.jsx';
import BryntumContext from '../../../../context/bryntumContext.jsx';
import { BryntumButton } from '@bryntum/schedulerpro-react';
import { VIEW_TYPES } from '../../../../../other/constants/OtherKeys.jsx';
import { useHistory } from "react-router-dom";
import { StringHelper } from "@bryntum/schedulerpro";
import useViews from "../../../../hooks/useViews.jsx";

export default function AppSwivuButton() {
  const history = useHistory();
  const context = useContext(BryntumContext);
  const { viewManager, selectedBoard, user, entityManager } = context;
  const { online } = useNetworkState();
  const viewManagerState = useViews();
  const isDisabled = !user || !selectedBoard;

  return (
    <BryntumButton
    icon={`fa-swivu fa-kit !text-[2em] text-[#058dec] ${!online ? "text-[#999]" : ""}`}
    cls="b-transparent p-0"
    disabled={isDisabled}
    onClick={() => {
      if (entityManager.isOpen) {
        entityManager.closeEntityManager();
        return;
      }

      if (viewManagerState?.selectedView?.viewType !== VIEW_TYPES.settings) {
        const id = StringHelper.generateUUID();
        history.push(`/${selectedBoard.record.slug}/${VIEW_TYPES.mySwivu}`, { viewId: id, viewType: VIEW_TYPES.mySwivu });
        viewManager.selectViewAnonymousView(id, "My Swivu", VIEW_TYPES.mySwivu);
      } else {
        viewManager.goToPreviousView();
      }
    }}
  />
  )
}
